<div class="modal-header" *ngIf="isModal">
	<h4 class="modal-title fw-bold">{{title}}</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
	</button>
</div>
<div class="modal-body">
	<nav>
		<ul class="nav nav-tabs">
			<li class="nav-item pe-1">
				<a class="nav-link" jhiTranslate="inventory-details.nav.lot"
				   [routerLink]="['lot']" [routerLinkActive]="['active']" queryParamsHandling="merge"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" jhiTranslate="inventory-details.nav.transaction"
				   [routerLink]="['transaction/']" [routerLinkActive]="['active']" [queryParams]="{lotId: null}" queryParamsHandling="merge"></a>
			</li>
		</ul>
	</nav>
	<div class="tab-content p-3">
		<router-outlet></router-outlet>
	</div>
</div>
